// extracted by mini-css-extract-plugin
export default {"pageBody":"PageBody_pageBody__5J6Dk"};